import type { ObjectType } from "@divespots/contracts";
import { BadgeInfo, CircleDot, Car, PersonStanding, Ship, SquareStack, Toilet } from "lucide-react";
import type { ComponentType } from "react";

/** Fixed glyph per object type (design/GUIDELINES.md, Iconography). */
const ICONS: Record<ObjectType, ComponentType<{ size?: number; strokeWidth?: number }>> = {
  figure: PersonStanding,
  toilet: Toilet,
  wreck: Ship,
  vehicle: Car,
  platform: SquareStack,
  plaque: BadgeInfo,
  other: CircleDot,
};

export function ObjectIcon({ type, size = 17 }: { type: ObjectType; size?: number }) {
  const Icon = ICONS[type];
  return <Icon size={size} strokeWidth={1.75} aria-hidden="true" />;
}
